import { useState } from 'react';
import { useIntl } from 'react-intl';
import { Button } from 'iglooform';
import _ from 'lodash';
import { emailReg } from '@/utils/regexp';
import { sendEmailOtp } from '@/pages/onboarding/service';
import './index.less';

export const OtpVerification = ({
  email,
  // verifiSuccess,
  // setVerifiSuccess,
  platformKey,
}: {
  email: string;
  // verifiSuccess: boolean;
  // setVerifiSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  platformKey: string;
}) => {
  const [countdown, setCountdown] = useState<number>(0);
  const [sendOtpLoading, setSendOtpLoading] = useState<boolean>(false);
  const { formatMessage } = useIntl();

  const emailFormatIsCorrect = !!email && emailReg.test(email.trim());

  const getOtp = () => {
    setSendOtpLoading(true);
    sendEmailOtp({
      email,
      platform: platformKey,
    })
      .then((res) => {
        if (res?.status === 'ok') {
          // 开启倒计时
          setCountdown(60);
          const timer = setInterval(() => {
            setCountdown((prevTime) => {
              if (prevTime - 1 === 0) {
                window.clearInterval(timer);
              }
              return prevTime - 1;
            });
          }, 1000);
        } else {
          //todo otp 验证失败
        }
      })
      .finally(() => {
        setSendOtpLoading(false);
      });
  };

  const getOtpThrottle = _.throttle(getOtp, 1000, {
    leading: true,
    trailing: false,
  });

  const countdownBtn = (
    <div className="countdownBtn">
      {formatMessage(
        {
          id: '{countdown}(s)',
          defaultMessage: '{countdown}(s)',
        },
        {
          countdown,
        },
      )}
    </div>
  );

  const verifyBtn = (
    <Button
      type="link"
      style={{ color: '#5858FF' }}
      loading={sendOtpLoading}
      disabled={!emailFormatIsCorrect}
      onClick={getOtpThrottle}
    >
      {formatMessage({
        id: 'Send OTP',
        defaultMessage: 'Send OTP',
      })}
    </Button>
  );

  const beforeVerifiSuccessBtn = countdown !== 0 ? countdownBtn : verifyBtn;

  return <div>{beforeVerifiSuccessBtn}</div>;
};
